import { Component, Input, SimpleChanges } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
 
// [formControl]="formControl" [formlyAttributes]="field"
  @Component({
    selector: 'custom-radiobutton',
    styles: [`
      label.checked {
        border-color: #006884;
        border-width: 2.5px;
      }
    `],
    template: `
    <div class="wrapper" *ngIf="to.myoptions"> 
      <div class="sub_blk" *ngFor="let option of to.myoptions; let i = index" (change)="onChange(option.value)">
        <input type="radio" [disabled]="to.disabled" name="to.name" id="{{option.value}}" class="radio_blk" 
        [ngClass]="{'checked': option.value == formControl.value }" [checked]="option.value == formControl.value" [disabled]="option.disabled">
        <label for="{{option.value}}" class="option" [ngClass]="{'checked': option.value == formControl.value }" >
         <span>{{option.label | translate}}</span>
        </label>
      </div>
      {{locationsType}}
    </div>
    `,
    standalone: false
})
   
  export class RadioButtonFormlyType extends FieldType {
    locationsType;
    isSelected:any;
    previousValue: string = '';
    constructor() {
      super();
    }

    ngOnInit(){
      this.isSelected = this.to.defaultset;
    }
    

    onChange(option: any) {
      if(this.to.disabled){
        return
      }
      this.formControl.patchValue(option);
      this.formControl.markAsTouched();
    }

  }
  